import { Swiper } from "swiper";
import { EffectFade, Pagination, Navigation, Autoplay } from 'swiper/modules';

if(document.getElementById("homeSwiper")) {
  const swiper = new Swiper('#homeSwiper', {
    modules: [ Pagination, EffectFade, Navigation, Autoplay],
    direction: 'horizontal',
    loop: true,
   effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: "fraction",
    },
    navigation: {
      nextEl: '.facts-swiper-button-next',
      prevEl: '.facts-swiper-button-prev',
    },
    autoplay: {
      delay: 8000,
      disableOnInteraction: true,
    },
    speed: 1200,
    slidesPerView: 1,
  });
  swiper.autoplay.start();
}

 
